<script lang="tsx">
  import { Component, defineComponent, h } from 'vue';
  import type { TableCellProps } from '@mts/render';
  import { omit } from '@mts-fe/utils';
  import BaseBadge from '@mts/components/Base/src/BaseBadge.vue';
  import BaseParagraph from '@mts/components/Base/src/BaseParagraph.vue';
  import BasePopover from '@mts/components/Base/src/BasePopover.vue';
  import BaseProgress from '@mts/components/Base/src/BaseProgress.vue';
  import BaseTag from '@mts/components/Base/src/BaseTag.vue';
  import ReadonlyNumber from '@mts/components/Base/src/ReadonlyNumber.vue';
  import ReadonlyText from '@mts/components/Form/src/components/ReadonlyText.vue';
  // import RenderColor from './CellRenderColor.vue';
  import RenderImage from './CellRenderImage.vue';
  import RenderLink from './CellRenderLink.vue';
  import RenderText from './CellRenderText.vue';
  import formatCell from './formatCell';

  /** 表格单元格预置组件 */
  const cellCompMap = new Map<string, Component>();
  cellCompMap.set('RenderTag', BaseTag);
  cellCompMap.set('RenderBadge', BaseBadge);
  cellCompMap.set('RenderParagraph', BaseParagraph);
  cellCompMap.set('RenderProgress', BaseProgress);
  cellCompMap.set('RenderPopover', BasePopover);
  cellCompMap.set('RenderLink', RenderLink);
  cellCompMap.set('RenderImage', RenderImage);
  // cellCompMap.set('RenderColor', RenderColor);
  cellCompMap.set('RenderDict', ReadonlyText);
  cellCompMap.set('RenderNumber', ReadonlyNumber);
  cellCompMap.set('RenderText', RenderText);

  const valueComps = [
    'RenderTag',
    'RenderBadge',
    'RenderParagraph',
    'RenderProgress',
    'RenderPopover',
    'RenderNumber',
    'RenderDict',
  ];

  export default ({ column: { format, render, ...column }, ...cellProps }: TableCellProps) => {
    let value = cellProps.text;
    if (format) {
      value = formatCell(value, format, cellProps.record, cellProps.index);
    }

    if (render?.type) {
      const Comp = cellCompMap.get(render.type) as ReturnType<typeof defineComponent>;

      if (valueComps.includes(render.type)) {
        if (render.type === 'RenderTag') {
          render.emptyShow = render.emptyShow ?? false;
        }
        if (render.type === 'RenderDict') {
          render.emptyText = render.emptyText ?? '';
        }
        return h(Comp, { column, ...cellProps, ...omit(render, ['type', 'api', 'params']), value });
      }

      return h(Comp, { ...cellProps, column, render: omit(render, ['type']) });
    }
    return value;
  };
</script>
